import { message } from 'antd';
import PublicLayout from './public';
import { useRecoilValue } from 'recoil';
import authAtom from '../atoms/auth/auth.atom';
import React, { Fragment, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthLayout from './auth';
import MainLayout from './main';
import { getSubdomain } from '../contexts/Utils';

const Layouts = {
  auth: AuthLayout,
  main: MainLayout,
  public: PublicLayout,
};

type Props = {
  children: React.ReactComponentElement<never> | React.ReactElement;
};
const Layout = ({ children }: Props) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isLoggedIn } = useRecoilValue(authAtom);
  const subdomain = getSubdomain();

  // Layout Rendering
  const getLayout = () => {
    if (/^\/page(?=\/|$)/i.test(pathname)) return 'public';
    if (/^\/auth(?=\/|$)/i.test(pathname)) return 'auth';
    return 'main';
  };

  const Container = Layouts[getLayout()];
  const isMainLayout = getLayout() === 'main';
  // const isAuthLayout = getLayout() === 'auth';

  useEffect(() => {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    const pathname = window.location.pathname;
    const search = window.location.search;

    const isLocalhost =
      hostname.includes('localhost') || hostname === '127.0.0.1';

    const subdomainExpected = 'app';

    // 🏗️ Subdomain is missing entirely, redirect to proper one
    if (!subdomain) {
      const newHost = isLocalhost
        ? `${subdomainExpected}.localhost:3000`
        : `${subdomainExpected}.${hostname}`;

      const newUrl = `${protocol}//${newHost}${pathname}${search}`;
      window.location.replace(newUrl);
    }
  }, []);

  // scroll to top when path changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // redirect to login page if current is not login page and user not authorized
  useEffect(() => {
    if (isMainLayout && !isLoggedIn) {
      message.info({
        content: 'please authenticate to proceed.',
        key: 'updatable',
      });
      navigate('/auth/login');
    }

    // if (isLoggedIn && isAuthLayout) {
    //   navigate('/');
    // }
  }, [isLoggedIn, isMainLayout, navigate]);
  return (
    <Fragment>
      <Container>{children}</Container>
    </Fragment>
  );
};

export default Layout;
